import React from 'react'
import shieldIcon from '../../../static/images/trust_signals_shield.svg'
import '../../styles/TrustSignalsModule/SmartAssetBadge.scss'

export const SmartAssetBadge = () => {
  return (
    <div className="trust-signals__smartasset">
      <img src={shieldIcon} alt="" aria-hidden="true" />
      <span>
        <strong>50K+</strong> investors<br />matched monthly
      </span>
    </div>
  )
}
